import Long from "long";
import { toDate } from "./toDate";
export function toTimestamp(value) {
    if (value == null) return undefined;
    return {
        seconds: Long.fromValue(toDate(value).getTime()).divide(Long.fromValue(1000)).toString(),
        nanos: 0
    };
}
